import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

/*Import Context */
import { UserContext } from "./UserContext";

/*Import API helpers */
import { fetchGET } from "../apiHelper";
import {
  podatkiZaRazpis,
  potDoPrograma,
  financniViriRazpisa,
  projektiZaRazpis,
} from "../listOfApi";

/* React-Bootstrap component */
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Table from "react-bootstrap/Table";

/*import React-icons */
import { AiOutlineInfoCircle } from "react-icons/ai";
import { BsGrid3X3GapFill } from "react-icons/bs";
import { BsFileText } from "react-icons/bs";

/*Import Components */
import FinancniViri from "./tenderDetails/FinancniViri";
import OsnovniPodatki from "./tenderDetails/OsnovniPodatki";

const TenderDetails = ({ role }) => {
  /*Pridobljen parameter iz ID */
  const { id } = useParams();
  const navigate = useNavigate();

  const [tenderDataDetails, setTenderDataDetails] = useState({
    razpis_naziv: "",
    obtezitev: 0,
    opis: "",
    povezava: "",
    pomemben: false,
    odprt: false,
    odprt_tekst: "",
    prijava_datum: "",
    prijava_ura: "",
    sifrantARRS: false,
    sifrantCERIF: false,
    sifrantKLASIUS: false,
    program_naziv: "",
    id_financiranje_kategorija: 0,
    financiranje_kategorija: "",
    program: [],
  });
  const [financialResources, setFinancialResources] = useState([]);
  const [projects, setProjects] = useState([]);
  const [invalidRazpisId, setInvalidRazpisId] = useState(false);

  /* Pridobivanje podatkov za razpis in finančne vire razpisa */
  useEffect(() => {
    getRazpis();
    getRazpisData();
    getProjects();
  }, []);

  /* Pridobi podatke za razpis */
  const getRazpis = () => {
    fetchGET(`${podatkiZaRazpis}/${id}`).then((razpis) => {
      if (razpis !== 0) {
        setTenderDataDetails({
          razpis_naziv: razpis.razpis_naziv,
          povezava: razpis.povezava,
          pomemben: razpis.pomemben,
          obtezitev: parseInt(razpis.obtezitev),
          odprt: razpis.odprt,
          odprt_tekst: razpis.odprt_tekst,
          opis: razpis.opis,
          prijava_datum: razpis.prijava_datum,
          prijava_ura: razpis.prijava_ura,
          sifrantARRS: razpis.sifrantARRS,
          sifrantCERIF: razpis.sifrantCERIF,
          sifrantKLASIUS: razpis.sifrantKLASIUS,
          program_naziv: razpis.program_naziv,
          programID: razpis.programID,
          financiranje_kategorija: razpis.financiranje_kategorija,
          id_financiranje_kategorija: razpis.id_financiranje_kategorija,
        });

        fetchGET(`${potDoPrograma}/${razpis.programID}`).then((poti) => {
          setTenderDataDetails((prevState) => {
            return { ...prevState, program: poti };
          });
        });
      } else {
        setInvalidRazpisId(true);
      }
    });
  };

  /* Pridobi podatke za finančne vire razpisa */
  const getRazpisData = () => {
    fetchGET(`${financniViriRazpisa}/${id}/financiranje`).then((vir) => {
      if (vir !== 0) {
        setFinancialResources(vir);
      } else {
        setFinancialResources([]);
      }
    });
  };

  /* Pridobi podatke za projekte razpisa */
  const getProjects = () => {
    fetchGET(`${projektiZaRazpis}/${id}/projekti`)
      .then((projekti) => {
        if (projekti !== 0) {
          setProjects(projekti);
        } else {
          setProjects([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching projects:", error);
      });
  };

  return (
    <Container fluid>
      {invalidRazpisId && <p>Razpis ne obstaja!</p>}
      {!invalidRazpisId && (
        <>
          {/* PROJEKT TITLE */}
          <Row>
            <Col className="main-header font-weight-bold">
              <AiOutlineInfoCircle className="me-2" />
              {tenderDataDetails.razpis_naziv}
            </Col>
            <Col>
              <div className="float-end">
                <Link className="programs-button-add-text ms-2" to={`/razpisi`}>
                  <Button variant="primary" className="button-back-razpisi ">
                    <BsGrid3X3GapFill /> <span>Razpisi</span>
                  </Button>
                </Link>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="header-divider">
              <hr />
            </Col>
          </Row>
          <Row>
            <Col>
              {/* TABS */}
              <Tabs defaultActiveKey="osnovni">
                {/* TAB - Osnovni podatki */}
                <Tab eventKey="osnovni" title="Osnovni podatki">
                  <UserContext.Provider value={role}>
                    <OsnovniPodatki
                      id={id}
                      tenderDataDetails={tenderDataDetails}
                      getRazpis={getRazpis}
                      getRazpisData={getRazpisData}
                    />
                  </UserContext.Provider>
                </Tab>
                {/* TAB - Finančni podatki */}
                <Tab eventKey="financniVir" title="Finančni viri">
                  <UserContext.Provider value={role}>
                    <FinancniViri
                      id={id}
                      financialResources={financialResources}
                      financiranjeKategorija={
                        tenderDataDetails.id_financiranje_kategorija
                      }
                      getRazpisData={getRazpisData}
                    />
                  </UserContext.Provider>
                </Tab>
                {/* TAB - Projekti */}
                <Tab eventKey="projekti" title="Projekti">
                  <UserContext.Provider value={role}>
                    <div className="mt-3">
                      <Table striped bordered hover responsive>
                        <thead>
                          <tr>
                            <th>Naslov projekta</th>
                            <th>Vloga UM v projektu</th>
                            <th>Status</th>
                            <th>Občanska znanost</th>
                            <th>Začetek projekta</th>
                            <th>Konec projekta</th>
                            <th>Datum vnosa</th>
                            <th>Podrobnosti projekta</th>
                          </tr>
                        </thead>
                        <tbody>
                          {projects.length > 0 ? (
                            projects.map((project, index) => (
                              <tr key={index}>
                                <td>{project.naslov}</td>
                                <td>{project.vloga_um}</td>
                                <td>{project.status}</td>
                                <td>
                                  {project.obcanska_znanost ? "Da" : "Ne"}
                                </td>
                                <td>{project.zacetek}</td>
                                <td>{project.konec}</td>
                                <td>{project.datum_vnosa}</td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <button
                                    style={{
                                      background: "transparent",
                                      border: "none",
                                      padding: "0",
                                      cursor: "pointer",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                    onClick={() =>
                                      window.open(
                                        project.link_podrobnosti,
                                        "_blank",
                                      )
                                    }
                                    title="Podrobnosti"
                                  >
                                    <BsFileText
                                      style={{
                                        fontSize: "1.5rem",
                                        color: "black",
                                      }}
                                    />
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">
                                Ni projektov za ta razpis
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </UserContext.Provider>
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};

export default TenderDetails;
